export const chartShowPath = (chartId: number) => `/charts/${chartId}/show`;
export const chartEditPath = (chartId: number) => `/charts/${chartId}/edit`;
export const chartNewPath = '/charts/new';